import React from 'react';
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";

import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
import { Container } from "react-bootstrap";
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import TextTrigger from "../../animation/TextTrigger";
import DsnGrid from "../../components/DsnGrid";
//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import ButtonProject from "../../components/button/button-project/ButtonProject";
import NextProject from "../../components/next/NextProject";
import BoxRight from "../../components/box-right/BoxRight";
import ParallaxImage from "../../components/parallax-image/ParallaxImage";
import { Helmet } from 'react-helmet-async';


const ToyotaWishGiver = ({ data }) => {

    const nextData = getPortfolioItem(4);


    return (
        <React.Fragment>
            <Helmet>
                <title>Devlift - {data.title} </title>
                <link rel='canonical' href='/portolio/toyota' />
                <meta
                    name="description"
                    content={data.description}
                />
            </Helmet>
            {/*Start Header Half*/}
            <HeaderHalf heroContent={data}
                href="#"
                overlay={data.overlay}>
                {/* <strong className="color-heading">Published </strong> <span> - July 15th 2019 </span> */}
            </HeaderHalf>
            {/*End Header Half*/}

            {/*Start Info Project*/}
            <Container className="section-margin">
                <TitleCover>The Ask</TitleCover>
                <TextTrigger duration={0.8} stagger={0.1}>
                    {(ref) => <h2 className="title-section" ref={ref}>The Ask</h2>}
                </TextTrigger>
                <FadeUpTrigger>
                    <p className="mt-20">
                        Devlift was asked to step in to deliver a custom microsite optimized for user experience and performance.
                    </p>
                    <p className="mt-20">
                        The Ontario Toyota Dealers decided to give back to Ontarians through their Toyota Wish Giver contest where individuals could become “wish givers” and nominate members in their community, who have gone above and beyond to help others, who give back and ask for nothing in return. The Top 10 stories with the most deserving individuals would see the nominee awarded with an amazing prize - a brand new Toyota Corolla.
                    </p>
                </FadeUpTrigger>
            </Container>
            {/*End Info Project*/}



            {/*Start Grid Project*/}
            <Container className="section-margin">
                <DsnGrid col={1} colGap={50} rowGap={50} colGapTablet={30} rowGapTablet={30}>
                    <img src="/assets/img/project/toyota/screenshot.png" alt="" />
                </DsnGrid>
            </Container>
            {/*Start Grid Project*/}



            {/*Start Box Info With Image*/}
            <BoxImageVertical src="/assets/img/project/toyota/logo.jpg" className="section-margin">
                <FadeUpTrigger>
                    {(ref) => <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
                        <TitleCover>The Solution</TitleCover>
                        <h2 className='title-section border-line-left' ref={ref}>The Solution</h2>

                        <p ref={ref}>
                            The Devlift team was able to not only construct a custom voting microsite built with the latest technology and refined user flows but they also delivered a robust back-end system that consisted of the ability to moderate entries with multiple administrative roles and multi-stage winner advancement.  The site also allowed for processing of multiple file formats for easier and faster uploads. Along with secure client side voting and accurate filtering of duplicate votes plus modern sharing and analytics tracking methods.
                        </p>


                    </DsnGrid>}
                </FadeUpTrigger>
            </BoxImageVertical>

            <Container className="section-margin">
                <DsnGrid col={1} colGap={50} rowGap={50} colGapTablet={30} rowGapTablet={30}>
                    <img src="/assets/img/project/toyota/wishgiver.png" alt="" />
                </DsnGrid>
            </Container>


            <NextProject heroContent={nextData} overlay={nextData.overlay} />


        </React.Fragment>
    );
}


export default ToyotaWishGiver;